import SkinPage from "../../SkinPage";
import Widget from "../../widgets/Widget";
import FeesList from "../../widgets/trading/FeesList";

const FeesView = () => {
  return (
     <SkinPage>
      <Widget name={"fees"}>
       <FeesList/>
      </Widget>
    </SkinPage>
  )
}

export default FeesView
